import React from "react";
import withFdsIconWrapper from './withFdsIconWrapper';

const ActionsArrowRightIcon = () => <svg viewBox="0 0 24 24"><g fillRule="evenodd"><g><polygon points="7.59699258 5.8399499 9.81546382 3.62147866 17.3944348 11.2004496 17.4106002 11.1842842 18.7101506 12.4838346 18.6939852 12.5 18.7101506 12.5161654 17.4106002 13.8157158 17.3944348 13.7995504 9.66997495 21.5240102 7.45150371 19.305539 14.2570427 12.5" /></g></g></svg>;

export default withFdsIconWrapper(ActionsArrowRightIcon);